import lookupStore from './LookupCodeStore';
import lovStore from './LovCodeStore';
const stores = {
    LovCodeStore: lovStore,
    LookupCodeStore: lookupStore,
};
export default stores;
